import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { Location } from '@angular/common';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class DataService {
  private adminSidebarVisible = new BehaviorSubject<boolean>(false);

  constructor(private router: Router, private location: Location, private http: HttpClient) { }

  setValue(key, value) {
    if (key && value) {
      localStorage.setItem(key, JSON.stringify(value));
    }
  }

  setUserToken(token) {
    if (token) {
      localStorage.setItem('token', token);
    }
  }
  setRoleId(roleId){
    localStorage.setItem('roleId', roleId);
  }

  getUserToken() {
    return localStorage.getItem('token');
  }

  logoutUser() {
    
    this.http.post(environment.baseUrl+'/user/logout', { login_log_id: this.getValue('log_id') }, {
      headers: { 'Content-Type': 'application/json', Auth: localStorage.getItem('token') }
    }).subscribe(res => { })
    localStorage.clear();
    if (this.router.url.split('/')[1] == "gym") {
      this.router.navigateByUrl('/login')
    }
    else if (this.router.url.split('/')[1] == "athletes") {
      this.router.navigateByUrl('/login')
    }
    else {
      this.router.navigateByUrl('/');
    }

  }

  saveUserInfo(userInfo) {
    localStorage.setItem('userInfo', JSON.stringify(userInfo));
  }

  getValue(key) {
    return JSON.parse(localStorage.getItem(key));
  }

  deleteValue(key) {
    localStorage.removeItem(key);
  }

  response(res) {
    if (res.statusCode == 200) {
      return res;
    } else if (res.statusCode == 401) {
      this.router.navigateByUrl('/sign-in');
    }
  }

  private appointmentDetails = new BehaviorSubject<object>(Object);
  appointment = this.appointmentDetails.asObservable();

  setAppointmentDetails(appointment) {
    this.appointmentDetails.next(appointment);
  }

  getSidebarVisibility(): Observable<boolean> {
    return this.adminSidebarVisible.asObservable();
  }

  toggleSidebarVisibility() {
    this.adminSidebarVisible.next(!this.adminSidebarVisible.value);
  }

  getSavedUserDetails() {
    return JSON.parse(localStorage.getItem('userInfo'));
  }

  getBack() {
    this.location.back();
  }

}
